import type { Event, EventHint, Breadcrumb, BreadcrumbHint } from '@sentry/react';
import type { Log } from '@sentry/core';

const PII_ATTRIBUTE_KEYS = ['email', 'ip_address', 'username', 'user_email'] as const;
const URL_DATA_KEYS = ['from', 'to', 'url'] as const;

export function scrubEvent(event: Event, _hint?: EventHint): Event | null {
  if (!event) return null;

  if (event.user) {
    event.user = { id: event.user.id };
  }

  return event;
}

export function scrubBreadcrumb(breadcrumb: Breadcrumb, _hint?: BreadcrumbHint): Breadcrumb | null {
  if (!breadcrumb) return null;

  const data = breadcrumb.data;
  if (!data) return breadcrumb;

  // Strip request bodies from network breadcrumbs
  if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
    delete data.body;
  }

  // Strip query params from all URL-like fields
  for (const key of URL_DATA_KEYS) {
    const val = data[key];
    if (typeof val === 'string' && val.includes('?')) {
      data[key] = val.slice(0, val.indexOf('?'));
    }
  }

  return breadcrumb;
}

export function scrubLogAttributes(log: Log): Log | null {
  if (!log) return null;

  const attrs = log.attributes;
  if (attrs) {
    for (const key of PII_ATTRIBUTE_KEYS) {
      delete attrs[key];
    }
  }

  return log;
}
